export default __webpack_public_path__ + "static/media/reluminate_thresh.51e67a3e.jpg";